import { globalModel } from "../../global/GlobalModel";
import { ShellTopBar } from "../shell/ShellTopBar";
import MyReportsPage from "../../customer_account/my-reports/MyReportsPage";

export default function PlatformMyReportsPage(): JSX.Element {
  return (
    <MyReportsPage
      fixedTopBar
      topBar={<ShellTopBar onLoginClick={() => globalModel.openLoginModal()} />}
    />
  );
}
